var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomInIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1435 20.0869L17.7267 18.6702C16.1917 19.9175 14.2342 20.6651 12.1021 20.6651C7.17277 20.6651 3.17676 16.6691 3.17676 11.7398C3.17676 6.81046 7.17277 2.81445 12.1021 2.81445C17.0314 2.81445 21.0274 6.81046 21.0274 11.7398C21.0274 13.8719 20.2798 15.8294 19.0325 17.3644L20.4492 18.7812L20.8845 18.3459L25.8088 23.2702L23.6325 25.4465L18.7082 20.5222L19.1435 20.0869ZM12.1021 18.8185C16.0116 18.8185 19.1808 15.6493 19.1808 11.7398C19.1808 7.83032 16.0116 4.66107 12.1021 4.66107C8.19263 4.66107 5.02338 7.83032 5.02338 11.7398C5.02338 15.6493 8.19263 18.8185 12.1021 18.8185ZM13.0254 10.8165H16.4109V12.6631H13.0254V16.0486H11.1788V12.6631H7.79331V10.8165H11.1788V7.43101H13.0254V10.8165Z",
    fill: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomInIcon);
export default __webpack_public_path__ + "static/media/ZoomInIcon.9e46efe2b3ac0ee3131914ce96164dd8.svg";
export { ForwardRef as ReactComponent };